function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "trendingUpIconTitle"
}, "Trending Up");

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "3 17 9 11 13 15 20.405 7.595"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  strokeLinecap: "round",
  d: "M20.4054613,7.59453873 L21,7"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "21 10 21 7 18 7"
});

var SvgTrendingUp = function SvgTrendingUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    "aria-labelledby": "trendingUpIconTitle",
    stroke: "#0A6054",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#0A6054",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "trendingUpIconTitle"
  }, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrendingUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trending-up.2af48754.svg";
export { ForwardRef as ReactComponent };